




















import throttle from 'lodash/throttle'

export default {
  name: 'altitude-control',
  data() {
    return {
      context: undefined,
      wheelHeight: undefined,
      wheelWidth: undefined,
      pxRatio: window.devicePixelRatio || 1,
      lastMove: {},
      waitForRedraw: false,
      bigLabel: false,
      bigLabelDebounce: 0,
      stepInc: undefined,
      nstep: undefined
    }
  },
  mounted() {
    this.$refs.bar.addEventListener('wheel', throttle(this.scrollMouseWheel, 100))
    this.context = this.$refs.wheel.getContext('2d')
    this.draw()
    window.addEventListener('resize', () => {
      this.draw()
    })
    window.addEventListener('keydown', this.keyScroll)
  },
  updated() {
  },
  computed: {
    angle() {
      return this.altitude * Math.PI * 2 / 1333
    },
    altitude() {
      return this.$store.state.persistent.altitude
    },
    roundedAltitude() {
      return this.$store.getters['persistent/roundedAltitude']
    },
    isVisible() {
      return this.$store.state.persistent.layer.substr(-4, 4) === 'alti'
    }
  },
  watch: {
    angle() {
      if (this.context !== undefined) {
        this.draw()
      }
    },
    isVisible() {
      if (this.isVisible) {
        this.showBigLabel()
        this.draw(true)
      }
    }
  },
  methods: {
    climb(height) {
      this.$store.dispatch('persistent/climbAltitude', height)
      this.showBigLabel()
    },
    beginMouseMove(e) {
      window.addEventListener('mousemove', this.mouseMove)
      window.addEventListener('mouseup', this.endMouseMove)
      window.addEventListener('mouseleave', this.endMouseMove)
      this.beginMove({ x: e.clientX, y: e.clientY })
    },
    beginTouchMove(e) {
      window.addEventListener('touchmove', this.touchMove)
      window.addEventListener('touchend', this.endTouchMove)
      window.addEventListener('touchleave', this.endTouchMove)
      this.beginMove({ x: e.touches[0].clientX, y: e.touches[0].clientY })
      this.bigLabel = true
      this.labelTimeoutArmed = false
    },
    endTouchMove() {
      window.removeEventListener('touchmove', this.touchMove)
      window.removeEventListener('touchend', this.endTouchMove)
      window.removeEventListener('touchleave', this.endTouchMove)
      this.labelTimeoutArmed = true
      setTimeout(() => {
        if (!this.labelTimeoutArmed) return
        this.bigLabel = false
        this.labelTimeoutArmed = false
      }, 500)
      this.endMove()
    },
    endMouseMove() {
      window.removeEventListener('mousemove', this.mouseMove)
      window.removeEventListener('mouseup', this.endMouseMove)
      window.removeEventListener('mouseleave', this.endMouseMove)
      this.endMove()
    },
    beginMove(origin) {
      this.lastMove = origin
      this.$store.dispatch('runtime/showDragSurface')
    },
    doMove(e) {
      const y = e.y - this.lastMove.y
      this.lastMove = e
      const metres = -y * 10
      this.climb(metres)
    },
    touchMove(e) {
      this.doMove({ x: e.touches[0].clientX, y: e.touches[0].clientY })
    },
    mouseMove(e) {
      this.doMove({ x: e.clientX, y: e.clientY })
    },
    endMove() {
      this.$store.dispatch('runtime/hideDragSurface')
    },
    scrollMouseWheel(e) {
      if (e.deltaY < 0) {
        this.climb(250)
      } else if (e.deltaY > 0) {
        this.climb(-250)
      }
    },
    showBigLabel() {
      this.bigLabel = true
      this.bigLabelDebounce = new Date().valueOf()
      setTimeout(() => {
        if ((new Date()).valueOf() < this.bigLabelDebounce + 800) return
        this.bigLabel = false
        this.bigLabelDebounce = 0
      }, 800)
    },
    draw(force) {
      if (!force && this.waitForRedraw) return
      this.waitForRedraw = true
      requestAnimationFrame(() => {
        this.wheelHeight = this.$refs.wheel.clientHeight * this.pxRatio
        this.wheelWidth = this.$refs.wheel.clientWidth * this.pxRatio
        this.$refs.wheel.height = this.wheelHeight
        this.$refs.wheel.width = this.wheelWidth
        this.nstep = this.wheelHeight / this.pxRatio / 2.5
        this.stepInc = (2 * Math.PI) / this.nstep
        // TODO redraw on resize

        const h = this.wheelHeight
        const w = this.wheelWidth

        this.context.clearRect(0, 0, w, h)
        let a = 0
        while (a < (2 * Math.PI)) {
          const centerSin = Math.sin(this.angle + a)
          const centerCos = Math.cos(this.angle + a)
          if (centerSin < 0) {
            a += this.stepInc
            continue
          }
          // if (centerSin < 0) continue;
          const hh = (centerSin * h) / this.nstep * 2
          if (a === 0) {
            this.context.fillStyle = `rgba(0, 85, 255, ${centerSin})`
          } else {
            this.context.fillStyle = `rgba(170, 170, 170, ${centerSin})`
          }
          // ctx.fillStyle = 'rgb(119, 119, 119)'
          // this.context.shadowColor = 'rgba(0, 0, 0, ' + centerCos + ')'
          this.context.fillRect(0, ((h / 2) + ((centerCos * h) / 2)) - (hh / 2), w, hh)
          a += this.stepInc
          this.waitForRedraw = false
        }
      })
    },
    keyScroll(e) {
      if (!this.isVisible) return
      switch (e.key) {
        case 'ArrowUp':
          this.climb(250)
          break
        case 'ArrowDown':
          this.climb(-250)
          break
        default:
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/altitude-control.vue